import { computed } from 'vue'
import { useSessionStore } from '@/store/pinia/SessionStore.ts'
import { WhitelabelDataType } from '@/types/WhiteLabelTypes.ts'

/**
 * Composable for accessing provider/whitelabel details
 * @returns Reactive provider details and computed licence information
 */
export const useProviderDetails = () => {
  const sessionStore = useSessionStore()
  const providerDetails: WhitelabelDataType = sessionStore.getWhitelabelData

  const licence = computed(() => {
    return providerDetails.afsl === '485665'
      ? `+ Australian Credit Licence ${providerDetails.afsl}`
      : providerDetails.afsl
  })

  return {
    providerDetails,
    licence
  }
}